import { Modal, ActionButton } from 'components/commons';
import { useApi } from 'hooks';
import locale from 'localization';
import React, { useCallback, useContext } from 'react';
import styles from './customer-account-claims-confirmation-modal.module.scss';
import { capitalize, formatAmount, handleRequest } from 'utils';
import { updateCustomerClaim } from 'apis/customer.api';
import { UserContext } from 'contexts';

const CustomerAccountClaimsConfirmationModal = ({
  refetchCustomerClaims,
  customerClaimId,
  close,
  active,
  interestAmount,
  status,
  requestAction
}) => {
  const user = useContext(UserContext);

  let title = 'Confirm to Transfer';
  let content = 'Are you sure you want to request to transfer';

  if (['approve', 'reject'].includes(status)) {
    title = `Confirm to ${capitalize(status)} Transfer to Savings`;
    content = 'Are you sure you want to transfer ';
  } else {
    title = 'Confirm to Request Transfer';
  }

  const { request: updateCustomerClaimRequest, loading: updatingCustomerAccount } = useApi({
    api: updateCustomerClaim
  });

  const updateStatusCb = useCallback(async () => {
    let newStatus = 'pending';
    let newRequestAction;

    if (user?.role === 'maker') {
      newStatus = 'pending';
      newRequestAction = requestAction;
    } else if (['approver', 'admin'].includes(user?.role)) {
      if (status === 'approve') {
        newStatus = 'claimed';
      } else {
        newStatus = 'rejected';
      }
    }

    handleRequest(async () => {
      await updateCustomerClaimRequest(
        { customerClaimId, status: newStatus, userId: user?.userId, requestAction: newRequestAction },
        () => updateStatusCb()
      );
      refetchCustomerClaims();
      close();
    });
  }, [
    user?.role,
    user?.userId,
    requestAction,
    status,
    updateCustomerClaimRequest,
    customerClaimId,
    refetchCustomerClaims,
    close
  ]);

  return (
    <Modal active={active} title={title} close={close} className={styles.modal}>
      <div className={styles.content}>
        {content} <b>{formatAmount(interestAmount)}</b> to Customer's <b>Savings Account?</b>
      </div>
      <ActionButton
        right
        items={[
          {
            text: locale.cancel,
            onClick: close
          },
          {
            loading: updatingCustomerAccount,
            onClick: updateStatusCb,
            text: 'Transfer'
          }
        ]}
      />
    </Modal>
  );
};

export default CustomerAccountClaimsConfirmationModal;
